import { LOAD_ACTIVITY, ADD_ACTIVITY } from '../actions/profileActivityAction'

export default function (state = { activities: [] }, action) {
  switch (action.type) {
    case LOAD_ACTIVITY:
      return { ...state, activities: action.activities }
    case ADD_ACTIVITY:
      return { ...state, activities: action.activities }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/profileActivityReducer.js